<template>
  <b-modal v-model="show" size="lg" centered header-bg-variant="primary" hide-footer title="Update Receipt Account" @show="setData" @hide="cancelModal()">
    <template v-if="show">
      <b-row>
        <b-col sm="12">
          <b-row>
            <b-col sm="12">
              <p-input v-model="form.paylinkUrl" label="Paylink Url" name="paylinkUrl" :handler="$v" :formData="form" type="text"/>
            </b-col>
            <b-col sm="6">
              <p-image v-model="form.bankLogo" label="Bank Logo" name="bankLogo" :handler="$v" :formData="form" />
            </b-col>
            <b-col sm="6">
              <p-image v-model="form.qrcode" label="QrCode Image" name="qrcode" :handler="$v" :formData="form" />
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12">
          <b-button variant="success" @click="submit()" :disabled="requesting">Update</b-button>
          <b-button variant="outline-danger" @click="cancelModal()">Cancel</b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>

import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import { PInput, PImage } from '../../../components'

export default {
  name: 'receipt-account-update',
  components: {
    PInput,
    PImage
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    updateData: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      requesting: false,
      qrcodeType: '',
      qrlink: '',
      form: {
        paylinkUrl: '',
        bankLogo: '',
        qrcode: '',
        errorMessages: {
          paylinkUrl: {},
          qrcode: {}
        }
      }
    }
  },
  validations: {
    form: {
      paylinkUrl: {},
      qrcode: {},
      bankLogo: {}
    }
  },
  computed: {
    show: {
      get: function () {
        return this.showModal
      },
      set: function () {
        return this.showModal
      }
    }
  },
  watch: {
    'form.qrcode': {
      immediate: true,
      handler: function (val) {
        this.qrcodeType = val === '' ? null : typeof val
      }
    }
  },
  methods: {
    async submit () {
      try {
        this.$v.form.$touch()
        if (!this.$v.form.$error) {
          this.requesting = true
          let formData = new FormData()
          formData.append('receiptAccountId', this.updateData.receiptAccountId)
          formData.append('paylinkUrl', this.form.paylinkUrl)
          formData.append('qrCode', this.form.qrcode)
          formData.append('bankLogo', this.form.bankLogo)
          // isQrDelete Type 0: Dont' Remove, 1: Remove
          formData.append('isQrDelete', this.qrcodeType === null ? 1 : 0)
          await this.$http.post(this.API_ENDPOINT + '/payment/manual/paylink/add', formData, { headers: { 'Content-Type': 'application/json' } })
          Events.$emit('alert', VueNotifications.types.success, 'Success', 'Update Successful')
          this.cancelModal()
          this.$emit('updateData')
        }
      } catch (err) {
        console.log('update receipt account error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        this.requesting = false
      }
    },
    setData () {
      this.form.paylinkUrl = this.updateData.paylinkUrl || ''
      this.form.qrcode = this.updateData.qrCode || ''
      this.form.bankLogo = this.updateData.bankLogo || ''
    },
    cancelModal () {
      this.form.paylinkUrl = ''
      this.form.qrcode = ''
      this.form.bankLogo = ''
      this.$v.form.$reset()
      this.$emit('closeModal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/payment/bank/UpdateReceiptAccount.vue